

export class DetailRequest {


   public vendorId: number;


    constructor(detailRequest: any) {
        this.vendorId = detailRequest.id || '';
    }
}
